export const getShortDateName = (time: number) => {
    const date = new Date(time);
    const year = date.getUTCFullYear().toString()
    const mounth = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}${mounth}${day}`
}


export const getDateName = (dataStr: number) => {
    const date = new Date(Number(dataStr));
    const year = date.getUTCFullYear().toString()
    const mounth = (date.getMonth() + 1).toString()
    const day = date.getDate().toString()
    return ` ${year}-${mounth}-${day}`;
}

export const getDateDetailName = (dataStr) => {
    const date = new Date(Number(dataStr));
    const year = date.getUTCFullYear().toString()
    const mounth = (date.getMonth() + 1).toString()
    const day = date.getDate().toString()

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${year}-${mounth}-${day} ${hours}:${minutes}:${seconds}`;
}